import React from 'react'
import { CardHeader } from 'packages/ui/CardPreview'
import { Site } from '../CardStyles'
import { WireLine } from '../../utils/types'

interface HeaderProps {
  wireLine: WireLine;
}

const Header: React.FC<HeaderProps> = ({ wireLine }) => {
  return (
    <CardHeader>
      <Site>{wireLine.wifirstsite?.name || '-'}</Site>
    </CardHeader>
  )
}

export default Header
